<template>
  <div
    v-if="elements"
    class="radio-button-group"
  >
    <input
      type="radio"
      class="radio-button-group-item"
      name="definedTips"
      v-for="(element, index) in elements"
      :key="index"
      v-model="vModel"
      :label="`${element.value} %`"
      :value="Math.trunc(amount * (element.value / 100))"
      @change="change(Math.trunc(amount * (element.value / 100)), index)"
      :style="{
        '--active-bg': profileColor,
        '--active-shadow': `0 0 4px ${profileColor}40, 0 0 8px ${profileColor}69`,
      }"
    >
  </div>
</template>

<script>
export default {
  name: 'DefinedTipsPercentage',
  props: {
    elements: {
      type: Array,
      default: () => {
        return [];
      }
    },
    model: {
      type: Number,
      default: 0
    },
    currency: {
      type: String,
      default: 'EUR'
    },
    amount: {
      type: Number,
      default: 0
    },
    primaryColor: {
      type: String,
      default: '#FF8A00'
    }
  },
  data() {
    return {
      checked: null,
    };
  },
  computed: {
    profileColor() {
      return this.primaryColor == null ? "#FF8A00" : this.primaryColor;
    },
    vModel: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit('update:model', value);
        this.$emit('change', value);
      }
    }
  },
  created () {
    this.elements.map((element, key) => {
      if (element.checked) {
        this.vModel = Math.trunc(this.amount * (element.value / 100));
        this.checked = key;
      }
    });
  },
  methods: {
    change (value, index) {
      this.$amplitude.logEvent('Payment page event Percents change', { qrCode: this.$route.params.qrCode, amount: value });
        this.$axios.post('/api/v1/fe-status', {
          status: 200,
          message: 'Payment page event Percents change',
          data: value,
          qrCode: this.$route.params.qrCode,
          timestamp: Date.now()
        });
      this.checked = index;
    }
  },
};
</script>

<style lang="scss" scoped>
.radio-button-group {
  height: 45px;
  background: #F6F7F9;
  border-radius: 24px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &-item {
    width: 100%;
    height: 100%;
    margin: 0;
    appearance: none;
    outline: none;
    cursor: pointer;
    color: #2D2E2F;
    font-size: 14px;
    font-family: "Raleway Bold", serif;
    font-feature-settings: 'pnum' on, 'lnum' on;

    &:checked {
      color: #FFFFFF;
      background-color: var(--active-bg);
      box-shadow: var(--active-shadow);
      border-radius: 24px;
    }

    &:before {
      content: attr(label);
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
  }
}
</style>
